import auth from "./Auth";
import home from "./Home";

const AccessControl = {
  ...auth,
  ...home,
};

export default AccessControl;
